/* NOMI v23.68: transparent cup images without the Safari PNG tax.
   Shopify's image CDN sniffs the user agent and hands every Safari / iOS browser a PNG
   (or JPEG) instead of the theme's .webp, 6–10x the bytes, and the browser's preload
   scanner fetches whatever is in src/srcset before any script runs. So the cup images
   ship with a 1x1 placeholder in src and the real URLs in data- attributes:
     data-b64         the .json twin ({w,h,t,d:base64 webp}), served untouched by the CDN
     data-b64-src     the sized .webp URL (what non-Safari browsers get)
     data-b64-srcset  the responsive srcset for the same
     data-b64-eager   set the image immediately (hero / above the fold); otherwise near-viewport
   Safari-family browsers decode the twin into a Blob; everyone else gets the webp URLs.
   Loaded in <head> before nomi.js (nomi-experience.js uses window.nomiB64 for the frames). */
(function () {
  var ua = navigator.userAgent || '';
  var safari = /AppleWebKit/.test(ua) && !/Chrome\/|Chromium\/|Android|Edg\//.test(ua);

  function isJson(u) { return /\.json(\?|$)/.test(u || ''); }
  function blob(url, prio) {
    var opts = {}; if (prio) opts.priority = prio;
    return fetch(url, opts).then(function (r) { if (!r.ok) throw new Error('b64 ' + r.status); return r.json(); }).then(function (j) {
      var s = atob(j.d), u = new Uint8Array(s.length);
      for (var i = 0; i < s.length; i++) u[i] = s.charCodeAt(i);
      return new Blob([u], { type: j.t || 'image/webp' });
    });
  }
  function image(b) {
    return new Promise(function (res, rej) {
      var im = new Image(); im.decoding = 'async';
      im.onload = function () { res(im); }; im.onerror = rej;
      im.src = URL.createObjectURL(b);
    });
  }
  /* set an <img> from a twin URL; a plain image URL is passed straight through; on any failure fall back to the .webp */
  function src(im, u) {
    if (!isJson(u)) { im.src = u; return; }
    blob(u, 'high').then(function (b) { im.src = URL.createObjectURL(b); })
      .catch(function () { im.src = u.replace(/\.json(\?|$)/, '.webp$1'); });
  }
  function isSvgImage(im) { return im.tagName && im.tagName.toLowerCase() === 'image'; }
  function setSrc(im, u) { if (isSvgImage(im)) im.setAttribute('href', u); else im.src = u; }
  function fallback(im) {
    var ss = im.getAttribute('data-b64-srcset'); if (ss && !isSvgImage(im)) im.setAttribute('srcset', ss);
    var s = im.getAttribute('data-b64-src'); if (s) setSrc(im, s);
  }
  function fill(im) {
    if (im.getAttribute('data-b64-done')) return;
    im.setAttribute('data-b64-done', '1');
    var j = im.getAttribute('data-b64');
    if (!safari || !j) { fallback(im); return; }
    blob(j, im.hasAttribute('data-b64-eager') ? 'high' : 'low').then(function (b) {
      im.removeAttribute('sizes'); im.removeAttribute('srcset');
      setSrc(im, URL.createObjectURL(b));
    }).catch(function () { fallback(im); });
  }
  window.nomiB64 = { blob: blob, image: image, src: src, isJson: isJson, safari: safari, fill: fill };

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fill(e.target); } });
  }, { rootMargin: '150% 0px' }) : null;
  function scan() {
    document.querySelectorAll('img[data-b64-src]:not([data-b64-seen]),img[data-b64]:not([data-b64-seen]),image[data-b64]:not([data-b64-seen])').forEach(function (im) {
      im.setAttribute('data-b64-seen', '1');
      if (im.hasAttribute('data-b64-eager') || !io) fill(im); else io.observe(im);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });
  /* <image> inside the x-ray SVGs (snippets/nomi-reveal.liquid) is handled the same way, via href */
})();
